export const clearPhone = (phone: string): string => phone.replace(/[^\d+]/g, '');
